import { render } from "./AppUserManagement.vue?vue&type=template&id=cdf80794"
import script from "./AppUserManagement.vue?vue&type=script&lang=js"
export * from "./AppUserManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__